import { Subject } from 'rxjs';

/**
 * Created by Alan Yang on 7/22/2018
 * Description:
 *
 * ---------maintenance history-------------
 */
export class NavigationMenuConfig {
    item: NavigationMenu;
    touchMode = false;
    seperator = false;
    eventSubject$: Subject<any>;
}

export class NavigationMenu {
    id: string;
    caption: string;
    type: string;
    icon: {
        name: string;
        style: string;
    };
    routerLink: string;
    items: NavigationMenu[];
    tid: string;
    canAdd: boolean;
    useWidget = false;
    hide = false;
    constructor(id: string, caption: string, type: string, icon: any, routerLink: string, items: NavigationMenu[], tid: string, canAdd: boolean = true, useWiget: boolean = false, hide = false) {
        this.id = id;
        this.caption = caption;
        this.type = type;
        this.icon = icon;
        this.routerLink = routerLink;
        this.items = items;
        this.tid = tid;
        this.canAdd = canAdd;
        this.useWidget = useWiget;
        this.hide = hide;
    }
}
